import { useMutation, useQueryClient } from "@tanstack/react-query";
import { importDefensiveFile } from "./importDefensiveFile";

export const useImportDefensiveFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: importDefensiveFile,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["defensives"]
            });
        }
    });
};
